<template>
  <div>
    <h3 class="mb-100">{{ $t('service.headline.certifications') }}</h3>

    <LcCard>
      <ul v-for="{ content, src, title } in items" :key="title" class="trust-item py-200 px-none">
        <li class="flex items-center">
          <NuxtImg :alt="title" class="trust-item-img mr-200" v-bind="{ src }" />

          <div class="paragraph-small-text">
            <ContentfulRenderer v-if="content?.json" :data="content" />
            <p v-else>
              {{ content }}
            </p>
          </div>
        </li>
      </ul>
    </LcCard>
  </div>
</template>

<script lang="ts" setup>
import type { TrustCertificates } from '#content/shared/@types/generated/cms/graphql-schema-types'

const { data } = useContent().getTrustCertificates()

const items = computed(() =>
  data.value?.items
    ? data.value.items.map((item: Maybe<TrustCertificates>) => ({
        content: item?.description,
        src: item?.certificate?.url ?? '',
        title: item?.title || '',
      }))
    : [],
)
</script>

<style lang="scss" scoped>
.trust-item {
  border-top: separator('line');

  &:first-child {
    padding-top: 0;
    border-top: none;
  }

  &:last-child {
    padding-bottom: 0;
  }

  &-img {
    width: 6rem;
  }
}
</style>
